export type SessionEvent = {type: 'logout' | 'login'; at: number};

const CHANNEL_NAME = 'mw-session-sync';

// BroadcastChannel: same-origin tabs in the same browser get each other's
// messages instantly; the sender does NOT receive its own (no echo to guard).
// Supported everywhere we ship (Safari >= 15.4, all evergreen). When absent we
// degrade gracefully — the visibilitychange probe (rootStore) still catches
// stale tabs on next focus.
const channel: BroadcastChannel | null =
  typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL_NAME) : null;

export function publishSessionEvent(event: SessionEvent): void {
  channel?.postMessage(event);
}

export function subscribeSessionEvents(handler: (event: SessionEvent) => void): () => void {
  if (!channel) {
    return () => {};
  }
  const listener = (message: MessageEvent<SessionEvent>) => {
    if (message.data?.type === 'logout' || message.data?.type === 'login') {
      handler(message.data);
    }
  };
  channel.addEventListener('message', listener);
  return () => channel.removeEventListener('message', listener);
}
